import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { Button, Flex } from '@electricjs/arc';

import { useStorefront } from '../../StorefrontProvider';
import { useIsEmbedded } from '@/hooks/useIsEmbedded';
import {
  usePostMessageToParent,
  EmbeddedStorefrontMessageType,
} from '@/hooks/postMessageToParent';

const StyledButton = styled(Button)`
  width: 100%;
  padding: 1.5rem 0rem;
`;

const QuickActions = () => {
  const { t } = useTranslation('storefront');
  const navigate = useNavigate();
  const { isEmbedded } = useIsEmbedded();
  const postMessageToParent = usePostMessageToParent();

  const { storefrontCheckoutForm, hasOnlyAssetsInCart, resetStorefront } =
    useStorefront();

  const employeeId = storefrontCheckoutForm?.getValues('employee')?.value;

  const handleGoBack = () => {
    // Post exit requested message to parent frame (hook handles embedded check)
    postMessageToParent({
      type: EmbeddedStorefrontMessageType.EXIT_REQUESTED,
      timestamp: new Date().toISOString(),
    });
  };

  return (
    <Flex vertical rowGap="2rem" width="100%">
      {!isEmbedded && employeeId && (
        <StyledButton
          id="view-employee-profile-button"
          variant="outline"
          onClick={() => navigate(`/employees/${employeeId}`)}>
          {t('sections.quickActions.viewEmployeeProfile')}
        </StyledButton>
      )}
      {!isEmbedded && !hasOnlyAssetsInCart && (
        <StyledButton
          id="track-order-status-button"
          variant="outline"
          onClick={() => navigate('/track-orders')}>
          {t('sections.quickActions.trackOrderStatus')}
        </StyledButton>
      )}
      {!isEmbedded && (
        <StyledButton
          id="start-another-order-button"
          variant="outline"
          onClick={() => resetStorefront()}>
          {t('sections.quickActions.startAnotherOrder')}
        </StyledButton>
      )}
      {isEmbedded && (
        <StyledButton id="go-back-button" onClick={handleGoBack}>
          {t('sections.quickActions.goBack')}
        </StyledButton>
      )}
    </Flex>
  );
};

export default QuickActions;
